<template>
  <div class="flex-column h-100">
    <div class="custom-tab-body-cont full-height">
      <update-item v-for="(entity) in entities" :key="entity.URI" :entity="entity" v-on:toggleGroup="toggleGroup" v-on:toggleSite="toggleSite"></update-item>
      <empty-placeholder v-if="entities.length===0" v-bind="placeholderProps"></empty-placeholder>
    </div>
    <div class="custom-tab-body-footer">
      <b-row>
        <b-col>
          <b-form-checkbox size="xl" class="select-all darkbg" :checked="selectAll" v-on:change="select($event)">Select All</b-form-checkbox>
        </b-col>
        <b-col class="text-right">
          <label class="selected-label">{{selectedEntitiesCount}} selected</label>
          <b-button v-if="!isActivated" variant="outline-danger" @click="sendAction('delete')" :disabled="$v.selectedItems.$invalid">
            Delete
            <spinner size="small" v-if="buttonLoaders.delete"></spinner>
          </b-button>
          <span id="tootltipButton-1">
            <b-button id="tooltipButton-disable" variant="primary" v-if="!isActivated" @click="sendAction('activate')" :disabled="$v.selectedItems.$invalid || !isUniqueThemeSelected">
              Activate
              <spinner size="small" v-if="buttonLoaders.activate"></spinner>
            </b-button>
          </span>
          <b-tooltip :disabled="isUniqueThemeSelected" id="testtooltip" target="tootltipButton-1" placement="top">
            You can activate only one theme on a website. Please review your selection.
          </b-tooltip>
          <b-button variant="primary" v-if="isActivated && type !='themes'" @click="sendAction('deactivate')" :disabled="$v.selectedItems.$invalid">Deactivate
            <spinner size="small" v-if="buttonLoaders.deactivate"></spinner>
          </b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import utilsMixin from '../../mixins/utils';
import updateItem from './updateItem';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import EmptyPlaceholder from '../Common/EmptyPlaceholder';

export default {
  name: 'entitymanager',
  props: ['entities', 'type', 'isActivated'],
  components: {
    updateItem,
    EmptyPlaceholder
  },
  computed: {
    selectedItems() {
      let sites = [];
      _.each(this.entities, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    selectedEntitiesCount() {
      return this.selectedItems.length;
    },
    isUniqueThemeSelected() {
      if (this.type === 'plugins') {
        return true;
      }
      let selectedThemes = this.selectedItems;
      let uniqueSelectedThemes = _.uniqBy(selectedThemes, 'siteID');
      return selectedThemes.length === uniqueSelectedThemes.length;
    }
  },
  mixins: [validationMixin, utilsMixin],
  validations: {
    selectedItems: {
      required
    }
  },
  data() {
    return {
      selectAll: false,
      buttonLoaders: {
        activate: false,
        deactivate: false,
        delete: false
      },
      placeholderProps: {
        text: () => {
          return `Looks like there are no ${this.type}.`;
        },
        type: 'neutral'
      }
    };
  },
  methods: {
    select(selectedValue, type) {
      this.$emit('selectAll', {
        type: this.type,
        value: selectedValue
      });
    },
    getSelectedItems(totalItems) {
      let sites = [];
      _.each(totalItems, update => {
        let selectedSites = _.filter(update.sites, { selected: true });
        sites = _.concat(sites, selectedSites);
      });
      return sites;
    },
    toggleGroup({ group, value }) {
      this.$store.commit({
        type: 'SELECT_GROUP_PLUGINS_AND_THEMES',
        sites: group.sites,
        value: value
      });
      group.selected = value;
    },
    toggleSite({ group, site, isSelected }) {
      this.$store.commit({
        type: 'SELECT_PLUGIN_AND_THEME',
        site: site,
        value: isSelected
      });
    },
    showActivateToolTip() {
      this.$root.$emit('bv::show::tooltip', 'testtooltip');
    },
    sendAction(action) {
      this.buttonLoaders[action] = true;
      let payload = {};
      payload.action = `manage${this.capitalizeFirstLetter(this.type)}`;
      payload.args = {};
      payload.args.params = {};
      let updateArray = {};
      let totalItems = this.entities;
      let selectedItems = this.getSelectedItems(totalItems);
      let groupBySites = _.groupBy(selectedItems, 'siteID');
      _.each(groupBySites, (sites, siteId) => {
        if (updateArray[siteId] == undefined) {
          updateArray[siteId] = {};
          updateArray[siteId][this.type] = [];
        }
        _.each(sites, site => {
          if (updateArray[siteId][site.type] == undefined) {
            updateArray[siteId][site.type] = [];
          }
          let item = {
            name: site.name,
            path: site.URI,
            action: action
          };
          if (this.type === 'themes') {
            item.stylesheet = site.URI;
          }
          updateArray[siteId][site.type].push(item);
        });
      });
      payload.args.params = updateArray;
      payload.requiredData = {
        getPluginsAndThemesV3: 1
      };
      this.$store
        .dispatch('sendAction', payload)
        .then(() => {
          this.buttonLoaders[action] = false;
          this.$store.commit('REMOVE_PLUGINS_AND_THEMES', selectedItems);
        })
        .catch(err => {});
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Manage/EntityManager.vue